import * as types from './LanguageActionTypes';
import i18n from '../../i18n';
import { dataService } from '../../Services/data/data.service';
import { store } from '../../index';

export const setLanguage = (language) => {
    i18n.changeLanguage(language);

    const email = store.getState().Login.email;
    if (email) {
        dataService.updateUserLanguage(email, language);
    }

    return {
        type: types.SET_LANGUAGE,
        payload: language,
    };
};
